// For full API documentation, including code examples, visit https://wix.to/94BuAAs

import wixLocation from 'wix-location';

$w.onReady(function () {
	// TODO: write your page related code here...
	let path = wixLocation.path;
	
	if (path[0] === "impressum") {
		$w('#impressumDot').show();
		$w('#uebermichDot').hide();
		$w('#angeboteDot').hide();
		$w('#werkstattDot').hide();
		$w('#agendaDot').hide();
		$w('#kontaktDot').hide();
		console.log("path is " + path[0]);
	}
});

// export function datenschutzShow_click(event) {
// 	// Add your code for this event here: 
// 	$w("#datenschutz").show();
// }